



















import { Component, Prop, Vue } from "vue-property-decorator";
import { MissingBannersReport } from "@/models/reports";
import { LayoutModule } from "@/store/layout";

@Component
export default class MissingBannersSummary extends Vue {
  @Prop({ default: [] }) data!: MissingBannersReport[];

  get loading(): boolean {
    return LayoutModule.loaderIsVisible;
  }

  details(): void {
    this.$router.push({
      name: "missingBanners",
      params: { summary: "false" },
    });
  }
}
